import React from 'react';
import { PersonInfo } from 'model/autogen/PersonInfo';
import { ItemSearchModel } from 'model/autogen/ItemSearchModel';
import { IAuthContextProps, withAuthContext } from 'components/with-auth-context';
import { PeopleRequestFactory } from 'model/autogen/PeopleController';
import Downshift from 'downshift';
import { TextField, Paper, MenuItem } from '@material-ui/core';
import { deburr } from 'lodash';
import Person from "@material-ui/icons/Person";
import { personToString } from './person-list-editor';


function renderInput(inputProps: any) {
    const {InputProps, classes, ref, clearSelection, ...other } = inputProps;
    
    return (
        <div style={{marginTop: '10px'}}>
            <TextField
                InputProps={{
                    inputRef: ref,
                    classes: {
                        root: classes.inputRoot,
                        input: classes.inputInput,
                    },
                    ...InputProps,
                }}
                {...other}
            />
        </div>
    );
}

interface IRenderSuggestionOptions {
    highlightedIndex: number | null;
    index: number;
    itemProps: any;
    selectedItem: string;
    suggestion: PersonInfo;
}

function renderSuggestion({ suggestion, index, itemProps, highlightedIndex, selectedItem }: IRenderSuggestionOptions) {
    const isHighlighted = highlightedIndex === index;
    const isSelected = selectedItem && selectedItem.length > 0;

    return (
        <MenuItem
            {...itemProps}
            key={suggestion.id}
            selected={isHighlighted}
            component="div"
            style={{
                fontWeight: isSelected ? 500 : 400,
            }}
        >
            <><Person /> {`${suggestion.firstName} ${suggestion.lastName}`}</>
        </MenuItem>
    );
}

export interface IPeopleListProps {
    onPersonSelected: (person: PersonInfo) => void;
    label: string;
    classes: any;
    shouldHaveValue?: boolean;
}

export interface IPeopleListState {
    searchString: string;
    results: ItemSearchModel[] | undefined;
    isSearching: boolean;
    suggestions: PersonInfo[];
}

export type PeopleListProps = IPeopleListProps & IAuthContextProps;
export class PeopleList extends React.Component<PeopleListProps, IPeopleListState> {
    constructor(props: PeopleListProps) {
        super(props);
        this.state = {
            searchString: "",
            results: undefined,
            isSearching: false,
            suggestions: [],
        }
    }
    componentDidMount = async () => {
        let suggestions = await this.props.callApi(f => PeopleRequestFactory.getAllPeople(f));
        this.setState({ suggestions,})
    }

    private getSuggestions = (value: any) => {
        const inputValue = deburr(value.trim()).toLowerCase();
        const inputLength = inputValue.length;
        let count = 0;

        return inputLength === 0
            ? []
            : this.state.suggestions.filter(suggestion => {
                const keep =
                    count < 5 && `${suggestion.firstName}`.slice(0, inputLength).toLowerCase() === inputValue || `${suggestion.lastName}`.slice(0, inputLength).toLowerCase() === inputValue || `${suggestion.firstName} ${suggestion.lastName}`.slice(0, inputLength).toLowerCase() === inputValue;

                if (keep) {
                    count += 1;
                }

                return keep;
            });
    }

    render(): JSX.Element {
        const { classes, shouldHaveValue } = this.props;
        return <div>
            <Downshift itemToString={personToString} onChange={this.props.onPersonSelected} onSelect={this.props.onPersonSelected}>
                {({
                    clearSelection,
                    getInputProps,
                    getItemProps,
                    highlightedIndex,
                    inputValue,
                    isOpen,
                    selectedItem,
                }) => (
                        <div className={classes.container}>
                            {shouldHaveValue === false ? clearSelection() : null}
                            {renderInput({
                                clearSelection,
                                fullWidth: true,
                                classes,
                                InputProps: getInputProps({
                                    placeholder: `Search for ${this.props.label}`,
                                    onChange: (e: any) => {
                                        if (e.target.value === '') {
                                            clearSelection()
                                        }
                                    },
                                }),
                            })}
                            <div>
                                {isOpen ? (
                                    <Paper className={classes.paper} square>
                                        {this.getSuggestions(inputValue).map((suggestion, index) =>
                                            renderSuggestion({
                                                suggestion,
                                                index,
                                                itemProps: getItemProps({ item: suggestion }),
                                                highlightedIndex,
                                                selectedItem,
                                            }),
                                        )}
                                    </Paper>
                                ) : null}
                            </div>
                        </div>
                    )}
            </Downshift>
        </div>
    }
}

export default withAuthContext(PeopleList);


// WEBPACK FOOTER //
// ./src/components/material/people-list.tsx